// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { PostAdminSetConfigData, PostAdminSetConfigResponse, PostOitNotificationPostData, PostCarrierTelnyxEventHandleEventData, GetCarrierTelnyxEmergencyAddressesListData, GetCarrierTelnyxEmergencyAddressesListResponse, PutCarrierTelnyxEmergencyAddressesUpdateData, PutCarrierTelnyxEmergencyAddressesUpdateResponse, GetCdrGetData, GetCdrGetResponse, PostCdrIngestIngestData, GetCdrRecordingGetMetaData, GetCdrRecordingGetMetaResponse, PostCdrRecordingGenerateRecordingData, PostCdrRecordingGenerateRecordingResponse, GetCdrRecordingGetPreparedRecordingContentData, GetCdrRecordingGetPreparedRecordingContentResponse, PostCdrRecordingGenerateTranscriptData, PostCdrRecordingGenerateTranscriptResponse, PostCdrRecordingGenerateSummaryData, PostCdrRecordingGenerateSummaryResponse, PostCdrRecordingRateSummaryData, PostCdrRecordingRateSummaryResponse, GetEndpointsListEndpointsData, GetEndpointsListEndpointsResponse, PostEndpointsCreateEndpointData, PostEndpointsCreateEndpointResponse, GetEndpointsGetEndpointData, GetEndpointsGetEndpointResponse, PutEndpointsUpdateEndpointData, PutEndpointsUpdateEndpointResponse, PostEndpointsAttachAdditionalExtensionData, PostEndpointsAttachAdditionalExtensionResponse, DeleteEndpointsDetachAdditionalExtensionData, DeleteEndpointsDetachAdditionalExtensionResponse, PutEndpointsUpdateAdditionalExtensionData, PutEndpointsUpdateAdditionalExtensionResponse, PostEndpointsProvisionEndpointData, PostEndpointsProvisionEndpointResponse, PostEndpointsRebootEndpointData, PostEndpointsRebootEndpointResponse, GetEndpointConfigsListConfigurationsData, GetEndpointConfigsListConfigurationsResponse, PostEndpointConfigsCreateConfigurationData, PostEndpointConfigsCreateConfigurationResponse, DeleteEndpointConfigsDeleteConfigurationData, DeleteEndpointConfigsDeleteConfigurationResponse, GetEndpointConfigsGetConfigurationData, GetEndpointConfigsGetConfigurationResponse, PutEndpointConfigsUpdateConfigurationData, PutEndpointConfigsUpdateConfigurationResponse, GetFaxesListFaxesData, GetFaxesListFaxesResponse, PostFaxesSendFaxData, PostFaxesSendFaxResponse, GetFaxesGetFaxData, GetFaxesGetFaxResponse, PostFaxesMarkFaxReadData, PostFaxesMarkFaxReadResponse, PostFaxesMarkFaxUnreadData, PostFaxesMarkFaxUnreadResponse, PostFaxesWebhookHandlePayloadData, GetFpbxRegistrationsGetRegistrationsData, GetFpbxRegistrationsGetRegistrationsResponse, PostFpbxRegistrationsPostRegistrationUpdateData, PostFpbxRegistrationsPostRegistrationUpdateResponse, DeleteAccessDeleteData, DeleteAccessDeleteResponse, GetAccessIndexData, GetAccessIndexResponse, PostAccessStoreData, PostAccessStoreResponse, GetAccessGetCompositeData, GetAccessGetCompositeResponse, PostAccessNotifyAccessReconfiguredData, PostAccessNotifyAccessReconfiguredResponse, GetNumbersListData, GetNumbersListResponse, PutNumbersUpdateData, PutNumbersUpdateResponse, PostNumbersQueueTelnyxSyncData, PostNumbersQueueTelnyxSyncResponse, GetExtensionsListExtensionsData, GetExtensionsListExtensionsResponse, GetExtensionsListDetailedExtensionsData, GetExtensionsListDetailedExtensionsResponse, PutExtensionsUpdateExtensionData, PutExtensionsUpdateExtensionResponse, DeleteSubscribedNumbersDeleteData, DeleteSubscribedNumbersDeleteResponse, GetSubscribedNumbersIndexData, GetSubscribedNumbersIndexResponse, PostSubscribedNumbersStoreData, PostSubscribedNumbersStoreResponse, GetSmsConversationsListConversationsData, GetSmsConversationsListConversationsResponse, PostSmsConversationsNewConversationData, PostSmsConversationsNewConversationResponse, GetSmsConversationsGetConversationData, GetSmsConversationsGetConversationResponse, GetSmsConversationsGetMessagesData, GetSmsConversationsGetMessagesResponse, PostSmsConversationsContinueConversationData, PostSmsConversationsContinueConversationResponse, PostSmsConversationsMarkMessageReadData, PostSmsConversationsMarkMessageReadResponse, PostSmsConversationsMarkMessageUnreadData, PostSmsConversationsMarkMessageUnreadResponse, PostInboundTelnyxSmsHandleData, PostInboundFlowrouteSmsHandleData, PostInboundOitSmsHandleData, GetVoicemailIndexData, GetVoicemailIndexResponse, GetVoicemailGetCountsData, GetVoicemailGetCountsResponse, DeleteVoicemailDeleteMessageData, DeleteVoicemailDeleteMessageResponse, PutVoicemailUpdateFlagData, PutVoicemailUpdateFlagResponse, GetVoicemailGetAudioData, GetVoicemailGetTranscriptionData, GetVoicemailGetTranscriptionResponse, GetHealthcheckIndexData, GetHealthcheckIndexResponse } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class AdminApi {
    public static postAdminSetConfig<ThrowOnError extends boolean = false>(options: Options<PostAdminSetConfigData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostAdminSetConfigResponse, unknown, ThrowOnError>({
            url: '/admin/config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class OitNotificationApi {
    public static postOitNotificationPost<ThrowOnError extends boolean = false>(options: Options<PostOitNotificationPostData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
            url: '/public/byoc/oit/notification/{accountId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CarrierTelnyxEventApi {
    public static postCarrierTelnyxEventHandleEvent<ThrowOnError extends boolean = false>(options: Options<PostCarrierTelnyxEventHandleEventData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
            url: '/public/carriers/telnyx/event',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CarrierTelnyxEmergencyAddressesApi {
    public static getCarrierTelnyxEmergencyAddressesList<ThrowOnError extends boolean = false>(options?: Options<GetCarrierTelnyxEmergencyAddressesListData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetCarrierTelnyxEmergencyAddressesListResponse, unknown, ThrowOnError>({
            url: '/carriers/telnyx/emergency-addresses',
            ...options
        });
    }
    
    public static putCarrierTelnyxEmergencyAddressesUpdate<ThrowOnError extends boolean = false>(options: Options<PutCarrierTelnyxEmergencyAddressesUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutCarrierTelnyxEmergencyAddressesUpdateResponse, unknown, ThrowOnError>({
            url: '/carriers/telnyx/emergency-addresses/{locationId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CdrApi {
    public static getCdrGet<ThrowOnError extends boolean = false>(options?: Options<GetCdrGetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetCdrGetResponse, unknown, ThrowOnError>({
            url: '/cdr',
            ...options
        });
    }
    
}

export class CdrIngestApi {
    public static postCdrIngestIngest<ThrowOnError extends boolean = false>(options: Options<PostCdrIngestIngestData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
            url: '/cdr',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CdrRecordingApi {
    public static getCdrRecordingGetMeta<ThrowOnError extends boolean = false>(options: Options<GetCdrRecordingGetMetaData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetCdrRecordingGetMetaResponse, unknown, ThrowOnError>({
            url: '/cdr/{id}/recording',
            ...options
        });
    }
    
    public static postCdrRecordingGenerateRecording<ThrowOnError extends boolean = false>(options: Options<PostCdrRecordingGenerateRecordingData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCdrRecordingGenerateRecordingResponse, unknown, ThrowOnError>({
            url: '/cdr/{id}/prepare-recording',
            ...options
        });
    }
    
    public static getCdrRecordingGetPreparedRecordingContent<ThrowOnError extends boolean = false>(options: Options<GetCdrRecordingGetPreparedRecordingContentData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetCdrRecordingGetPreparedRecordingContentResponse, unknown, ThrowOnError>({
            url: '/cdr/{id}/prepared-recording',
            ...options
        });
    }
    
    public static postCdrRecordingGenerateTranscript<ThrowOnError extends boolean = false>(options: Options<PostCdrRecordingGenerateTranscriptData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCdrRecordingGenerateTranscriptResponse, unknown, ThrowOnError>({
            url: '/cdr/{id}/generate-transcript',
            ...options
        });
    }
    
    public static postCdrRecordingGenerateSummary<ThrowOnError extends boolean = false>(options: Options<PostCdrRecordingGenerateSummaryData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCdrRecordingGenerateSummaryResponse, unknown, ThrowOnError>({
            url: '/cdr/{id}/generate-summary',
            ...options
        });
    }
    
    public static postCdrRecordingRateSummary<ThrowOnError extends boolean = false>(options: Options<PostCdrRecordingRateSummaryData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCdrRecordingRateSummaryResponse, unknown, ThrowOnError>({
            url: '/cdr/{id}/rate-summary',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class EndpointsApi {
    public static getEndpointsListEndpoints<ThrowOnError extends boolean = false>(options?: Options<GetEndpointsListEndpointsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetEndpointsListEndpointsResponse, unknown, ThrowOnError>({
            url: '/endpoints',
            ...options
        });
    }
    
    public static postEndpointsCreateEndpoint<ThrowOnError extends boolean = false>(options: Options<PostEndpointsCreateEndpointData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostEndpointsCreateEndpointResponse, unknown, ThrowOnError>({
            url: '/endpoints',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getEndpointsGetEndpoint<ThrowOnError extends boolean = false>(options: Options<GetEndpointsGetEndpointData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetEndpointsGetEndpointResponse, unknown, ThrowOnError>({
            url: '/endpoints/{id}',
            ...options
        });
    }
    
    public static putEndpointsUpdateEndpoint<ThrowOnError extends boolean = false>(options: Options<PutEndpointsUpdateEndpointData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutEndpointsUpdateEndpointResponse, unknown, ThrowOnError>({
            url: '/endpoints/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postEndpointsAttachAdditionalExtension<ThrowOnError extends boolean = false>(options: Options<PostEndpointsAttachAdditionalExtensionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostEndpointsAttachAdditionalExtensionResponse, unknown, ThrowOnError>({
            url: '/endpoints/{id}/additional-extensions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteEndpointsDetachAdditionalExtension<ThrowOnError extends boolean = false>(options: Options<DeleteEndpointsDetachAdditionalExtensionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteEndpointsDetachAdditionalExtensionResponse, unknown, ThrowOnError>({
            url: '/endpoints/{endpointId}/additional-extensions/{id}',
            ...options
        });
    }
    
    public static putEndpointsUpdateAdditionalExtension<ThrowOnError extends boolean = false>(options: Options<PutEndpointsUpdateAdditionalExtensionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutEndpointsUpdateAdditionalExtensionResponse, unknown, ThrowOnError>({
            url: '/endpoints/{endpointId}/additional-extensions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postEndpointsProvisionEndpoint<ThrowOnError extends boolean = false>(options: Options<PostEndpointsProvisionEndpointData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostEndpointsProvisionEndpointResponse, unknown, ThrowOnError>({
            url: '/endpoints/{id}/provision',
            ...options
        });
    }
    
    public static postEndpointsRebootEndpoint<ThrowOnError extends boolean = false>(options: Options<PostEndpointsRebootEndpointData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostEndpointsRebootEndpointResponse, unknown, ThrowOnError>({
            url: '/endpoints/{id}/reboot',
            ...options
        });
    }
    
}

export class EndpointConfigsApi {
    public static getEndpointConfigsListConfigurations<ThrowOnError extends boolean = false>(options?: Options<GetEndpointConfigsListConfigurationsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetEndpointConfigsListConfigurationsResponse, unknown, ThrowOnError>({
            url: '/endpoint-configs',
            ...options
        });
    }
    
    public static postEndpointConfigsCreateConfiguration<ThrowOnError extends boolean = false>(options: Options<PostEndpointConfigsCreateConfigurationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostEndpointConfigsCreateConfigurationResponse, unknown, ThrowOnError>({
            url: '/endpoint-configs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteEndpointConfigsDeleteConfiguration<ThrowOnError extends boolean = false>(options: Options<DeleteEndpointConfigsDeleteConfigurationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteEndpointConfigsDeleteConfigurationResponse, unknown, ThrowOnError>({
            url: '/endpoint-configs/{id}',
            ...options
        });
    }
    
    public static getEndpointConfigsGetConfiguration<ThrowOnError extends boolean = false>(options: Options<GetEndpointConfigsGetConfigurationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetEndpointConfigsGetConfigurationResponse, unknown, ThrowOnError>({
            url: '/endpoint-configs/{id}',
            ...options
        });
    }
    
    public static putEndpointConfigsUpdateConfiguration<ThrowOnError extends boolean = false>(options: Options<PutEndpointConfigsUpdateConfigurationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutEndpointConfigsUpdateConfigurationResponse, unknown, ThrowOnError>({
            url: '/endpoint-configs/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class FaxesApi {
    public static getFaxesListFaxes<ThrowOnError extends boolean = false>(options?: Options<GetFaxesListFaxesData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetFaxesListFaxesResponse, unknown, ThrowOnError>({
            url: '/faxes',
            ...options
        });
    }
    
    public static postFaxesSendFax<ThrowOnError extends boolean = false>(options: Options<PostFaxesSendFaxData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostFaxesSendFaxResponse, unknown, ThrowOnError>({
            url: '/faxes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getFaxesGetFax<ThrowOnError extends boolean = false>(options: Options<GetFaxesGetFaxData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetFaxesGetFaxResponse, unknown, ThrowOnError>({
            url: '/faxes/{id}',
            ...options
        });
    }
    
    public static postFaxesMarkFaxRead<ThrowOnError extends boolean = false>(options: Options<PostFaxesMarkFaxReadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostFaxesMarkFaxReadResponse, unknown, ThrowOnError>({
            url: '/faxes/{id}/read',
            ...options
        });
    }
    
    public static postFaxesMarkFaxUnread<ThrowOnError extends boolean = false>(options: Options<PostFaxesMarkFaxUnreadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostFaxesMarkFaxUnreadResponse, unknown, ThrowOnError>({
            url: '/faxes/{id}/unread',
            ...options
        });
    }
    
}

export class FaxesWebhookApi {
    public static postFaxesWebhookHandlePayload<ThrowOnError extends boolean = false>(options: Options<PostFaxesWebhookHandlePayloadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
            url: '/public/faxes/webhook',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class FpbxRegistrationsApi {
    public static getFpbxRegistrationsGetRegistrations<ThrowOnError extends boolean = false>(options?: Options<GetFpbxRegistrationsGetRegistrationsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetFpbxRegistrationsGetRegistrationsResponse, unknown, ThrowOnError>({
            url: '/fpbx/registrations',
            ...options
        });
    }
    
    public static postFpbxRegistrationsPostRegistrationUpdate<ThrowOnError extends boolean = false>(options: Options<PostFpbxRegistrationsPostRegistrationUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostFpbxRegistrationsPostRegistrationUpdateResponse, unknown, ThrowOnError>({
            url: '/fpbx/registrations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class AccessApi {
    public static deleteAccessDelete<ThrowOnError extends boolean = false>(options: Options<DeleteAccessDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteAccessDeleteResponse, unknown, ThrowOnError>({
            url: '/access',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getAccessIndex<ThrowOnError extends boolean = false>(options?: Options<GetAccessIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetAccessIndexResponse, unknown, ThrowOnError>({
            url: '/access',
            ...options
        });
    }
    
    public static postAccessStore<ThrowOnError extends boolean = false>(options: Options<PostAccessStoreData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostAccessStoreResponse, unknown, ThrowOnError>({
            url: '/access',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getAccessGetComposite<ThrowOnError extends boolean = false>(options?: Options<GetAccessGetCompositeData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetAccessGetCompositeResponse, unknown, ThrowOnError>({
            url: '/access/composite',
            ...options
        });
    }
    
    public static postAccessNotifyAccessReconfigured<ThrowOnError extends boolean = false>(options: Options<PostAccessNotifyAccessReconfiguredData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostAccessNotifyAccessReconfiguredResponse, unknown, ThrowOnError>({
            url: '/access/notify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class NumbersApi {
    public static getNumbersList<ThrowOnError extends boolean = false>(options?: Options<GetNumbersListData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetNumbersListResponse, unknown, ThrowOnError>({
            url: '/numbers',
            ...options
        });
    }
    
    public static putNumbersUpdate<ThrowOnError extends boolean = false>(options: Options<PutNumbersUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutNumbersUpdateResponse, unknown, ThrowOnError>({
            url: '/numbers/{numberId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postNumbersQueueTelnyxSync<ThrowOnError extends boolean = false>(options: Options<PostNumbersQueueTelnyxSyncData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNumbersQueueTelnyxSyncResponse, unknown, ThrowOnError>({
            url: '/numbers/{numberId}/queue-telnyx-sync',
            ...options
        });
    }
    
}

export class ExtensionsApi {
    public static getExtensionsListExtensions<ThrowOnError extends boolean = false>(options?: Options<GetExtensionsListExtensionsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetExtensionsListExtensionsResponse, unknown, ThrowOnError>({
            url: '/extensions',
            ...options
        });
    }
    
    public static getExtensionsListDetailedExtensions<ThrowOnError extends boolean = false>(options?: Options<GetExtensionsListDetailedExtensionsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetExtensionsListDetailedExtensionsResponse, unknown, ThrowOnError>({
            url: '/extensions/detailed',
            ...options
        });
    }
    
    public static putExtensionsUpdateExtension<ThrowOnError extends boolean = false>(options: Options<PutExtensionsUpdateExtensionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutExtensionsUpdateExtensionResponse, unknown, ThrowOnError>({
            url: '/extensions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SubscribedNumbersApi {
    public static deleteSubscribedNumbersDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSubscribedNumbersDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSubscribedNumbersDeleteResponse, unknown, ThrowOnError>({
            url: '/subscribed-numbers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getSubscribedNumbersIndex<ThrowOnError extends boolean = false>(options?: Options<GetSubscribedNumbersIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSubscribedNumbersIndexResponse, unknown, ThrowOnError>({
            url: '/subscribed-numbers',
            ...options
        });
    }
    
    public static postSubscribedNumbersStore<ThrowOnError extends boolean = false>(options: Options<PostSubscribedNumbersStoreData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSubscribedNumbersStoreResponse, unknown, ThrowOnError>({
            url: '/subscribed-numbers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SmsConversationsApi {
    public static getSmsConversationsListConversations<ThrowOnError extends boolean = false>(options?: Options<GetSmsConversationsListConversationsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSmsConversationsListConversationsResponse, unknown, ThrowOnError>({
            url: '/sms/conversations',
            ...options
        });
    }
    
    public static postSmsConversationsNewConversation<ThrowOnError extends boolean = false>(options: Options<PostSmsConversationsNewConversationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSmsConversationsNewConversationResponse, unknown, ThrowOnError>({
            url: '/sms/conversations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getSmsConversationsGetConversation<ThrowOnError extends boolean = false>(options: Options<GetSmsConversationsGetConversationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSmsConversationsGetConversationResponse, unknown, ThrowOnError>({
            url: '/sms/conversations/{id}',
            ...options
        });
    }
    
    public static getSmsConversationsGetMessages<ThrowOnError extends boolean = false>(options: Options<GetSmsConversationsGetMessagesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSmsConversationsGetMessagesResponse, unknown, ThrowOnError>({
            url: '/sms/conversations/{conversationId}/messages',
            ...options
        });
    }
    
    public static postSmsConversationsContinueConversation<ThrowOnError extends boolean = false>(options: Options<PostSmsConversationsContinueConversationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSmsConversationsContinueConversationResponse, unknown, ThrowOnError>({
            url: '/sms/conversations/{conversationId}/messages',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSmsConversationsMarkMessageRead<ThrowOnError extends boolean = false>(options: Options<PostSmsConversationsMarkMessageReadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSmsConversationsMarkMessageReadResponse, unknown, ThrowOnError>({
            url: '/sms/conversations/{conversationId}/messages/{messageId}/read',
            ...options
        });
    }
    
    public static postSmsConversationsMarkMessageUnread<ThrowOnError extends boolean = false>(options: Options<PostSmsConversationsMarkMessageUnreadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSmsConversationsMarkMessageUnreadResponse, unknown, ThrowOnError>({
            url: '/sms/conversations/{conversationId}/messages/{messageId}/unread',
            ...options
        });
    }
    
}

export class InboundTelnyxSmsApi {
    public static postInboundTelnyxSmsHandle<ThrowOnError extends boolean = false>(options: Options<PostInboundTelnyxSmsHandleData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
            url: '/public/sms/inbound/telnyx',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class InboundFlowrouteSmsApi {
    public static postInboundFlowrouteSmsHandle<ThrowOnError extends boolean = false>(options: Options<PostInboundFlowrouteSmsHandleData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
            url: '/public/sms/inbound/flowroute',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class InboundOitSmsApi {
    public static postInboundOitSmsHandle<ThrowOnError extends boolean = false>(options: Options<PostInboundOitSmsHandleData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
            url: '/public/sms/inbound/oit',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class VoicemailApi {
    public static getVoicemailIndex<ThrowOnError extends boolean = false>(options?: Options<GetVoicemailIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetVoicemailIndexResponse, unknown, ThrowOnError>({
            url: '/voicemail',
            ...options
        });
    }
    
    public static getVoicemailGetCounts<ThrowOnError extends boolean = false>(options?: Options<GetVoicemailGetCountsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetVoicemailGetCountsResponse, unknown, ThrowOnError>({
            url: '/voicemail/counts',
            ...options
        });
    }
    
    public static deleteVoicemailDeleteMessage<ThrowOnError extends boolean = false>(options: Options<DeleteVoicemailDeleteMessageData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteVoicemailDeleteMessageResponse, unknown, ThrowOnError>({
            url: '/voicemail/{extensionId}/{id}',
            ...options
        });
    }
    
    public static putVoicemailUpdateFlag<ThrowOnError extends boolean = false>(options: Options<PutVoicemailUpdateFlagData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutVoicemailUpdateFlagResponse, unknown, ThrowOnError>({
            url: '/voicemail/{extensionId}/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getVoicemailGetAudio<ThrowOnError extends boolean = false>(options: Options<GetVoicemailGetAudioData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/voicemail/{extensionId}/{id}/audio',
            ...options
        });
    }
    
    public static getVoicemailGetTranscription<ThrowOnError extends boolean = false>(options: Options<GetVoicemailGetTranscriptionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetVoicemailGetTranscriptionResponse, unknown, ThrowOnError>({
            url: '/voicemail/{extensionId}/{id}/transcription',
            ...options
        });
    }
    
}

export class HealthcheckApi {
    public static getHealthcheckIndex<ThrowOnError extends boolean = false>(options?: Options<GetHealthcheckIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetHealthcheckIndexResponse, unknown, ThrowOnError>({
            url: '/healthz',
            ...options
        });
    }
    
}